import { message } from "antd";
import { baseRequest } from "../../util/Api";
import { v4 } from "uuid";

export const getAffiliates = (filter) => {
  return new Promise((resolve, reject) => {
    baseRequest("get", "/affiliates/", filter)
      .then((data) => {
        resolve(data)
      }).catch((e) => {
        reject(e)
      })
  })
}